namespace RioERP.Web.Enums {
    export enum EInvoiceNumberPattern {
        InvoiceCompanyCode = 1,
        MonthYear = 2,
        OrderSource = 3,
        SequentialNumber = 4,
        FinancialYear = 5
    }
    Serenity.Decorators.registerEnumType(EInvoiceNumberPattern, 'RioERP.Web.Enums.EInvoiceNumberPattern');
}
